// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","selectionContainer":"onfido-sdk-ui-RestrictedDocumentSelection-selectionContainer"};